/**
 * Dropdown options for Kitchen Tip inherit / override on location + merchant profiles.
 */

function enabledLabel(enabled) {
  return enabled ? 'Enabled' : 'Disabled';
}

/** Location (parent): inherit from organization, or explicit override. */
export function getLocationKitchenTipOptions(organizationEnabled = false) {
  return [
    {
      value: null,
      label: `${enabledLabel(organizationEnabled)} - Inherited from organization`,
    },
    { value: true, label: 'Enabled' },
    { value: false, label: 'Disabled' },
  ];
}

/**
 * Merchant: inherit from organization/location, or explicit override.
 * Label uses the resolved parent value (org → location).
 */
export function getMerchantKitchenTipOptions(parentResolved = false) {
  return [
    {
      value: null,
      label: `${enabledLabel(parentResolved)} - Inherited from organization/location`,
    },
    { value: true, label: 'Enabled' },
    { value: false, label: 'Disabled' },
  ];
}
